import { render, staticRenderFns } from "./GeneralFakture.vue?vue&type=template&id=439bb364"
import script from "./GeneralFakture.vue?vue&type=script&lang=js"
export * from "./GeneralFakture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports